__turbopack_context__.v({
  "grid": "Grid-module__FwMyYq__grid",
  "gridItem": "Grid-module__FwMyYq__gridItem",
  "gridItemSpan2": "Grid-module__FwMyYq__gridItemSpan2",
  "gridItemSpan3": "Grid-module__FwMyYq__gridItemSpan3",
  "gridItemSpan4": "Grid-module__FwMyYq__gridItemSpan4",
  "gridItemSpan5": "Grid-module__FwMyYq__gridItemSpan5",
  "gridRowSpan2": "Grid-module__FwMyYq__gridRowSpan2",
  "gridRowSpan3": "Grid-module__FwMyYq__gridRowSpan3",
  "gridRowSpan4": "Grid-module__FwMyYq__gridRowSpan4",
  "gridRowSpan5": "Grid-module__FwMyYq__gridRowSpan5",
  "nested": "Grid-module__FwMyYq__nested",
  "responsive": "Grid-module__FwMyYq__responsive",
});
